/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useState } from "react";
export default function Header() {
  const [show, setShow] = useState(true);
  const [activeMenus, setActiveMenus] = useState({
    access: false,
    developers: false,
    learn: false,
    community: false,
  });
  const toggleMenu = (menu) => {
    setActiveMenus((prevState) => {
      const newState = Object.keys(prevState).reduce((acc, key) => {
        acc[key] = key === menu ? !prevState[menu] : false;
        return acc;
      }, {});
      return newState;
    });
  };

  return (
    <>
      <header className="header header--1 header--fixed">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <nav
                className={
                  show
                    ? "menu d-lg-flex justify-content-lg-between align-items-lg-center py-3 py-lg-0"
                    : "menu d-lg-flex justify-content-lg-between align-items-lg-center py-3 py-lg-0 menu-open"
                }
              >
                <div className="d-flex align-items-center justify-content-between">
                  <a
                    href="/"
                    className="logo link d-inline-flex align-items-center flex-shrink-0"
                  >
                    <img

                      src="assets/img/zenochain_dark_logo.svg"
                      width={200}

                      alt="logo"
                      className="img-fluid object-fit-contain"
                    />
                  </a>
                  <button
                    className="menu-toggle w-10 h-10 p-2 border-0 lh-1 bg-primary-50 clr-neutral-100 :clr-neutral-100 transition :bg-primary-300 rounded flex-shrink-0 d-lg-none order-sm-3 fs-24"
                    onClick={() => setShow(!show)}
                  >
                    <i className="bi bi-list" />
                  </button>
                </div>
                <div className="menu-nav d-flex align-items-lg-center flex-column flex-lg-row flex-grow-1 gap-4 pb-4 pb-lg-0 rounded">
                  <ul className="list list-lg-row mx-lg-auto">
                    <li className="menu-list">
                      <a
                        href="#yes"
                        className={`link menu-link has-sub menu-link-active ${activeMenus.access ? "active" : ""
                          }`}
                        onClick={() => toggleMenu("access")}
                      >
                        Access
                      </a>
                      <ul
                        className={`list menu-sub ${activeMenus.access ? "d-block" : "d-none"
                          }`}
                        id="yes"
                      >
                        <li className="menu-sub-list">
                          <a
                            href="/"
                            className="link menu-sub-link gap-3 gap-4"
                          >
                            <span className="d-none d-lg-inline-block">
                              <img
                                src="assets/icon-1/Zenodan_wallet.svg" width={20}
                                alt="image"
                                className="img-fluid"
                              />
                            </span>
                            Zenochain Wallet
                          </a>
                        </li>
                        <li className="menu-sub-list">
                          <a
                            href="/"
                            className="link menu-sub-link gap-3"
                          >
                            <span className="d-none d-lg-inline-block">
                              <img
                                src="assets/icon-1/Zenodan_explorer.svg"
                                width={20}
                                alt="image"
                                className="img-fluid"
                              />
                            </span>
                            Zenochain Explorer
                          </a>
                        </li>
                        <li className="menu-sub-list">
                          <a
                            href="/"
                            className="link menu-sub-link gap-3"
                          >
                            <span className="d-none d-lg-inline-block">
                              <img
                                src="assets/icon-1/staking (1).svg" width={20}
                                alt="image"
                                className="img-fluid"
                              />
                            </span>
                            Staking
                          </a>
                        </li>
                        <li className="menu-sub-list">
                          <a
                            href="/"
                            className="link menu-sub-link gap-3"
                          >
                            <span className="d-none d-lg-inline-block">
                              <img
                                src="assets/icon-1/validators (1).svg" width={20}
                                alt="image"
                                className="img-fluid"
                              />
                            </span>
                            Validators
                          </a>
                        </li>
                        <li className="menu-sub-list">
                          <a
                            href="/"
                            className="link menu-sub-link gap-3"
                          >
                            <span className="d-none d-lg-inline-block">
                              <img
                                src="assets/icon-1/ecosystem (1).svg"
                                width={20}
                                alt="image"
                                className="img-fluid"
                              />
                            </span>
                            Ecosystem
                          </a>
                        </li>
                      </ul>
                    </li>
                    <li className="menu-list">
                      <a
                        href="/#"
                        className={`link menu-link has-sub ${activeMenus.developers ? "active" : ""
                          }`}
                        onClick={() => toggleMenu("developers")}
                      >
                        Developer
                      </a>
                      <ul
                        className={`list menu-sub ${activeMenus.developers ? "d-block" : "d-none"
                          }`}
                      >
                        <li className="menu-sub-list">
                          <a
                            href="/"
                            target="_blank"
                            className="link menu-sub-link gap-3"
                          >
                            <span className="d-none d-lg-inline-block">
                              <img
                                src="assets/icon-1/run_a_node (1).svg"
                                width={20}
                                alt="image"
                                className="img-fluid"
                              />
                            </span>
                            Run a node
                          </a>
                        </li>
                        <li className="menu-sub-list">
                          <a
                            href="/"
                            target="_blank"
                            className="link menu-sub-link gap-3"
                          >
                            <span className="d-none d-lg-inline-block">
                              <img
                                src="assets/icon-1/grants (1).svg" width={20}
                                alt="image"
                                className="img-fluid"
                              />
                            </span>
                            Grants
                          </a>
                        </li>
                        <li className="menu-sub-list">
                          <a
                            href="/"
                            className="link menu-sub-link gap-3"
                          >
                            <span className="d-none d-lg-inline-block">
                              <img
                                src="assets/icon-1/accelatore (1).svg"
                                width={20}
                                alt="image"
                                className="img-fluid"
                              />
                            </span>
                            Accelerator
                          </a>
                        </li>
                        <li className="menu-sub-list">
                          <a
                            href="/"
                            target="_blank"
                            className="link menu-sub-link gap-3"
                          >
                            <span className="d-none d-lg-inline-block">
                              <img
                                src="assets/icon-1/apis (1).svg" width={20}
                                alt="image"
                                className="img-fluid"
                              />
                            </span>
                            APIs
                          </a>
                        </li>
                      </ul>
                    </li>
                    <li className="menu-list">
                      <a
                        href="#"
                        className={`link menu-link has-sub ${activeMenus.learn ? "active" : ""
                          }`}
                        onClick={() => toggleMenu("learn")}
                      >
                        Learn
                      </a>
                      <ul
                        className={`list menu-sub ${activeMenus.learn ? "d-block" : "d-none"
                          }`}
                      >
                        <li className="menu-sub-list">
                          <a
                            href="/"
                            target="_blank"
                            className="link menu-sub-link gap-3"
                          >
                            <span className="d-none d-lg-inline-block">
                              <img
                                src="assets/icon-1/whitepaper (1).svg"
                                width={20}
                                alt="image"
                                className="img-fluid"
                              />
                            </span>
                            Whitepaper
                          </a>
                        </li>
                        <li className="menu-sub-list">
                          <a
                            href="/"
                            target="_blank"
                            className="link menu-sub-link gap-3"
                          >
                            <span className="d-none d-lg-inline-block">
                              <img
                                src="assets/icon-1/litepaper (1).svg"
                                width={20}
                                alt="image"
                                className="img-fluid"
                              />
                            </span>
                            Litepaper
                          </a>
                        </li>
                        <li className="menu-sub-list">
                          <a
                            href="/"
                            target="_blank"
                            className="link menu-sub-link gap-3"
                          >
                            <span className="d-none d-lg-inline-block">
                              <img
                                src="assets/icon-1/documentations (1).svg"
                                width={20}
                                alt="image"
                                className="img-fluid"
                              />
                            </span>
                            Documentation
                          </a>
                        </li>
                      </ul>
                    </li>
                    <li className="menu-list">
                      <a
                        href="#"
                        className={`link menu-link has-sub ${activeMenus.community ? "active" : ""
                          }`}
                        onClick={() => toggleMenu("community")}
                      >
                        Community
                      </a>
                      <ul
                        className={`list menu-sub ${activeMenus.community ? "d-block" : "d-none"
                          }`}
                      >
                        <li className="menu-sub-list">
                          <a
                            href="/"
                            className="link menu-sub-link gap-3"
                          >
                            <span className="d-none d-lg-inline-block">
                              <img
                                src="assets/icon-1/governance (1).svg"
                                width={20}
                                alt="image"
                                className="img-fluid"
                              />
                            </span>
                            Governance
                          </a>
                        </li>
                        <li className="menu-sub-list">
                          <a href="/" className="link menu-sub-link gap-3">
                            <span className="d-none d-lg-inline-block">
                              <img
                                src="assets/icon-1/blogs (1).svg"
                                width={20}
                                alt="image"
                                className="img-fluid"
                              />
                            </span>
                            Blogs
                          </a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                  <ul className="list list-lg-row gap-4 gap-lg-6 ">

                    <li className="menu-list mx-4 mx-lg-0">
                      <a
                        href="/"
                        className="gradient-btn-1 position-relative z-1 link d-inline-flex justify-content-center px-4 py-2 rounded fw-bold text-center"
                      >
                        {" "}
                        Join alliances{" "}
                      </a>
                    </li>
                  </ul>
                </div>
              </nav>
            </div>
          </div>
        </div>
      </header>
    </>
  );
}
